export default "__VITE_ASSET__582248f3__"